export class EventManager {
    private events: Array<() => void> = [];

    /**
     * Attach an event listener to an element
     * @param event The name of the event to listen for
     * @param listener The event listener function or object
     * @param options Optional options for the event listener
     * @param element The element to attach the event listener to (defaults to window)
     */
    on(event: string, listener: EventListenerOrEventListenerObject, options?: boolean | AddEventListenerOptions, element: Window | HTMLElement = window): void {
        element.addEventListener(event, listener, options);

        this.events.push(() => {
            element.removeEventListener(event, listener, options);
        });
    }

    /**
     * Emit a custom event
     * @param eventName The name of the event to emit
     * @param detail Optional data to include in the event detail
     * @param element The element to dispatch the event on (defaults to window)
     */
    emit<T = unknown>(eventName: string, detail?: T, element: Window | HTMLElement = window): void {
        const event = new CustomEvent(eventName, { detail });
        element.dispatchEvent(event);
    }

    /**
     * Remove all event listeners created by this manager
     */
    removeEventListeners() {
        this.events.forEach((off) => off());
        this.events.splice(0, this.events.length);
    }
}
